import { render, staticRenderFns } from "./WorkflowButton.vue?vue&type=template&id=0c724a54&scoped=true&"
import script from "./WorkflowButton.vue?vue&type=script&lang=js&"
export * from "./WorkflowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c724a54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
